import React from 'react';
import { ApolloError } from '@apollo/client';
import { BuildingDelete } from './BuildingDelete';
import { useBuildingDeleteMutation } from '../../../__generated__/types';

interface BuildingDeleteContainerProps {
  id: string;
  isOpen: boolean;
  onCompleted: () => void;
  onCancel: () => void;
  onError: (error: Error | ApolloError) => void;
}

export const BuildingDeleteContainer: React.FC<
  BuildingDeleteContainerProps
> = ({ id, isOpen, onCompleted, onError, onCancel }) => {
  const [deleteBuilding, { loading, error }] = useBuildingDeleteMutation({
    onCompleted,
    onError,
  });

  const handleConfirm = () =>
    deleteBuilding({
      variables: { buildingId: id },
    });

  return (
    <BuildingDelete
      error={error}
      isLoading={loading}
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onClose={onCancel}
    />
  );
};
